import React, { useMemo } from 'react'
import CellContent from './CellContent'
import BodyText from 'LuxKit/Typography/BodyText'
import { formatDynamicDateRange } from 'lib/datetime/dateUtils'
import { groupBy } from 'lib/array/arrayUtils'
import getObjectKey from 'lib/object/getObjectKey'

interface Props {
  offer: App.HotelOffer
  filters: App.OfferListFilters
  packageUniqueKey?: string
  selections: Array<App.OfferComparisonSelection>
}

function LEHotelDateCell({ offer, filters, packageUniqueKey, selections }: Props) {
  const checkIn = filters.checkIn
  const checkOut = filters.checkOut

  const currentSelectionKey = getObjectKey({
    offerId: offer.id,
    packageUniqueKey,
  })

  const groups = groupBy(selections, selection => getObjectKey({
    offerId: selection.offerId,
    packageUniqueKey: selection.params?.packageUniqueKey,
  }))

  const allSamePackage = currentSelectionKey && groups.size === 1 && groups.has(currentSelectionKey)

  const formattedDateRange = useMemo(() => {
    if (checkIn && checkOut) {
      const dateRange = formatDynamicDateRange(checkIn, checkOut)
      if (!dateRange) return false
      return dateRange
    }
    return false
  }, [checkIn, checkOut])

  return (
    <CellContent>
      {/* We only want to show this column if the comparison is the same package */}
      {formattedDateRange && allSamePackage && <BodyText variant="medium">{formattedDateRange}</BodyText>}
    </CellContent>
  )
}

export default LEHotelDateCell
